import Log from '../../logger/Log';
const TAG = 'screen/registered';
let inited = false;
const sizes = [
    {
        size: 'xs',
        value: 480,
    },
    {
        size: 'sm',
        value: 576,
    },
    {
        size: 'md',
        value: 768,
    },
    {
        size: 'lg',
        value: 992,
    },
    {
        size: 'xl',
        value: 1200,
    },
    {
        size: 'xxl',
        value: 1600,
    },
];
export function resize(pkg) {
    Log.debug(TAG, 'resize start', pkg);
    const root = document.documentElement;
    const rootWidth = root.clientWidth;
    const xsValue = sizes[0].value;
    if (rootWidth < xsValue) { // 移动端自适应, 设计稿375
        root.style.fontSize = rootWidth / 375 * 16 + 'px';
    }
    else {
        root.style.fontSize = '16px';
    }
    const finded = sizes.find((item, index) => {
        if (index === sizes.length - 1 && rootWidth >= item.value) {
            return true;
        }
        if (rootWidth >= item.value && rootWidth < sizes[index + 1].value) {
            return true;
        }
        return false;
    });
    const size = finded ? finded.size : 'xxs';
    Log.debug(TAG, 'resize size', size);
    pkg.$store.commit('resize', size);
    Log.debug(TAG, `rootWidth:${rootWidth}, rootStyle${root.style.fontSize}`);
}
export default function registered(pkg) {
    if (inited) {
        return;
    }
    resize(pkg);
    window.addEventListener('resize', () => { resize(pkg); }, false);
    window.addEventListener('orientationchange', () => { resize(pkg); }, false);
    inited = true;
}
